/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams are built from 5 drivers + 2 constructors. With 20 drivers and 10 constructors, that's C(20,5)×C(10,2) = 697,680 combinations.`)
};

const es_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los equipos se forman con 5 pilotos + 2 constructores. Con 20 pilotos y 10 constructores, eso da C(20,5)×C(10,2) = 697,680 combinaciones.`)
};

const de_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams bestehen aus 5 Fahrern + 2 Konstrukteuren. Mit 20 Fahrern und 10 Konstrukteuren ergibt das C(20,5)×C(10,2) = 697.680 Kombinationen.`)
};

const nl_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams bestaan uit 5 coureurs + 2 constructeurs. Met 20 coureurs en 10 constructeurs geeft dat C(20,5)×C(10,2) = 697.680 combinaties.`)
};

const fr_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les équipes sont constituées de 5 pilotes + 2 constructeurs. Avec 20 pilotes et 10 constructeurs, cela donne C(20,5)×C(10,2) = 697 680 combinaisons.`)
};

const it_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I team sono composti da 5 piloti + 2 costruttori. Con 20 piloti e 10 costruttori, sono C(20,5)×C(10,2) = 697.680 combinazioni.`)
};

const pt_br2_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As equipes são formadas por 5 pilotos + 2 construtores. Com 20 pilotos e 10 construtores, são C(20,5)×C(10,2) = 697.680 combinações.`)
};

const pt_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As equipas são formadas por 5 pilotos + 2 construtores. Com 20 pilotos e 10 construtores, são C(20,5)×C(10,2) = 697.680 combinações.`)
};

const ja_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームは5ドライバー + 2コンストラクターで構成。20ドライバーと10コンストラクターでC(20,5)×C(10,2) = 697,680通りの組み合わせ。`)
};

const zh_f1_apex_help_calculation_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车队由5名车手 + 2支车队构成。20名车手和10支车队共有C(20,5)×C(10,2) = 697,680种组合。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_help_calculation_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_help_calculation_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_help_calculation_desc", locale)
	if (locale === "en") return en_f1_apex_help_calculation_desc(inputs)
	if (locale === "es") return es_f1_apex_help_calculation_desc(inputs)
	if (locale === "de") return de_f1_apex_help_calculation_desc(inputs)
	if (locale === "nl") return nl_f1_apex_help_calculation_desc(inputs)
	if (locale === "fr") return fr_f1_apex_help_calculation_desc(inputs)
	if (locale === "it") return it_f1_apex_help_calculation_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_help_calculation_desc(inputs)
	if (locale === "pt") return pt_f1_apex_help_calculation_desc(inputs)
	if (locale === "ja") return ja_f1_apex_help_calculation_desc(inputs)
	return zh_f1_apex_help_calculation_desc(inputs)
};